import { ReactComponent as BgIcon } from 'assets/images/lang/lang-bg-icon.min.svg';
import { ReactComponent as CnIcon } from 'assets/images/lang/lang-cn-icon.min.svg';
import { ReactComponent as CsIcon } from 'assets/images/lang/lang-cs-icon.min.svg';
import { ReactComponent as DeIcon } from 'assets/images/lang/lang-de-icon.min.svg';
import { ReactComponent as ElIcon } from 'assets/images/lang/lang-el-icon.min.svg';
import { ReactComponent as EnIcon } from 'assets/images/lang/lang-en-icon.min.svg';
import { ReactComponent as EsIcon } from 'assets/images/lang/lang-es-icon.min.svg';
import { ReactComponent as FrIcon } from 'assets/images/lang/lang-fr-icon.min.svg';
import { ReactComponent as HiIcon } from 'assets/images/lang/lang-hi-icon.min.svg';
import { ReactComponent as HrIcon } from 'assets/images/lang/lang-hr-icon.min.svg';
import { ReactComponent as HuIcon } from 'assets/images/lang/lang-hu-icon.min.svg';
import { ReactComponent as ItIcon } from 'assets/images/lang/lang-it-icon.min.svg';
import { ReactComponent as LtIcon } from 'assets/images/lang/lang-lt-icon.min.svg';
import { ReactComponent as LvIcon } from 'assets/images/lang/lang-lv-lang.min.svg';
import { ReactComponent as PlIcon } from 'assets/images/lang/lang-pl-icon.min.svg';
import { ReactComponent as RoIcon } from 'assets/images/lang/lang-ro-icon.min.svg';
import { ReactComponent as SkIcon } from 'assets/images/lang/lang-sk-lang.min.svg';
import { ReactComponent as SLIcon } from 'assets/images/lang/lang-sl-icon.min.svg';
import { ReactComponent as TrIcon } from 'assets/images/lang/lang-tr-icon.min.svg';

export const langIcons: Record<string, JSX.Element> = {
  en: <EnIcon />,
  de: <DeIcon />,
  fr: <FrIcon />,
  es: <EsIcon />,
  it: <ItIcon />,
  pl: <PlIcon />,
  tr: <TrIcon />,
  bg: <BgIcon />,
  cn: <CnIcon />,
  el: <ElIcon />,
  hu: <HuIcon />,
  ro: <RoIcon />,
  hi: <HiIcon />,
  cs: <CsIcon />,
  hr: <HrIcon />,
  lt: <LtIcon />,
  lv: <LvIcon />,
  sk: <SkIcon />,
  sl: <SLIcon />,
  kn: <HiIcon />,
};
